module.exports = __webpack_public_path__ + "static/img/1.30f580a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/1.png
// module id = eyhx
// module chunks = 0